import { memo } from 'react';

import useStyles from './styles';
import { IIndeterminateProgressProps } from './types';

function Progress({ type }: IIndeterminateProgressProps) {
  const classes = useStyles({ type });

  return (
    <div className={classes.root}>
      <div className={classes.bar}></div>
    </div>
  );
}

export const IndeterminateProgress = memo(Progress);
